export const buildRangeState = (startDate, endDate) => [
  {
    startDate,
    endDate,
    key: "selection",
  },
];

/** Off-screen date so the visible month has no blue selection until user picks a range */
const HIDDEN_RANGE_DATE = new Date(2099, 11, 31);

/** Calendar opens on today; no visible pre-selected range */
export const buildEmptyRangeState = () => [
  {
    startDate: HIDDEN_RANGE_DATE,
    endDate: HIDDEN_RANGE_DATE,
    key: "selection",
  },
];

export const dateRangePickerProps = {
  shownDate: new Date(),
  moveRangeOnFirstSelection: false,
  showMonthAndYearPickers: false,
  showDateDisplay: false,
};

/** True when the user picked a range in the visible calendar (not the hidden placeholder) */
export const hasVisibleDateSelection = (rangeState) => {
  const start = rangeState?.[0]?.startDate;
  return Boolean(start && start.getFullYear() < 2099);
};

export const formatDateForAPI = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

/** Omits fromdate & todate when user has not applied a range */
export const buildDashboardQuery = (fromdate, todate) => {
  if (!fromdate || !todate) return "";

  const params = new URLSearchParams();
  params.set("fromdate", fromdate);
  params.set("todate", todate);
  return params.toString();
};
